import React, { useRef } from 'react';
import styled, { css } from 'styled-components';

import { ContentWrapper } from 'components/core';
import { AddressTextButton } from 'components/location-settings-popover';
import { LocationSettingsControllerDark } from 'src/components/location-settings-popover/location-settings-controller-dark';
import MyAccountLink from './my-account-link';
import CartButtonMobile from './cart-button-mobile';
import { HeaderLogo } from './header-logo';

export const GlobalHeaderMobileDark = ({
  href,
  route,
  itemCount,
  globalHeaderRef,
  address,
  orderType,
  isDispensaryList,
  toggleCartView,
  badgeVariant,
  onSaveLocationSettings,
  onAddressTextButtonClick,
}) => {
  const locationAnchorRef = useRef(null);

  return (
    <Wrapper id='global-header' isDispensaryList={isDispensaryList}>
      <ContentWrapper bg='var(--rds-plum)' flexGrow={0}>
        <Container ref={globalHeaderRef}>
          <ContentGroup>
            <HeaderLogo href={href} route={route} isDark />
          </ContentGroup>

          <ContentGroup>
            <DropdownContainer>
              <MyAccountLink />
            </DropdownContainer>

            <DropdownContainer>
              <CartButtonMobile
                onButtonClick={toggleCartView}
                itemCount={itemCount}
                badgeVariant={badgeVariant}
                variant='white'
              />
            </DropdownContainer>
          </ContentGroup>
        </Container>
      </ContentWrapper>

      <AddressBarWrapper ref={locationAnchorRef} data-testid='dropdown-mobile'>
        <AddressTextButton onClick={onAddressTextButtonClick} address={address} orderType={orderType} />
        <LocationSettingsControllerDark onSave={onSaveLocationSettings} anchorEl={locationAnchorRef} />
      </AddressBarWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.15);
  width: 100%;
  z-index: 1200;

  ${({ isDispensaryList }) =>
    isDispensaryList &&
    css`
      position: fixed;
      width: 100%;
    `}
`;

const Container = styled.header`
  padding: 0 20px;
  position: relative;
  z-index: 1200;
  background-color: var(--rds-plum);
  display: flex;
  height: 55px;
  width: 100%;
  justify-content: space-between;
`;

const ContentGroup = styled.div`
  display: flex;
  align-items: center;
`;

const DropdownContainer = styled.div`
  align-items: center;
  position: relative;
`;

const AddressBarWrapper = styled.div`
  align-items: center;
  position: relative;

  div[class*='dropdown'] {
    left: -50%;
    top: 54px;
  }

  /* Address bar row inherits dark bg from AddressTextButton's mobile styles */
  && > button,
  && > [role='button'],
  && > div:first-child {
    background: var(--rds-plum-dark);
  }
`;
